import { render, staticRenderFns } from "./SignTermsAndConditions.vue?vue&type=template&id=941235cc&scoped=true"
import script from "./SignTermsAndConditions.vue?vue&type=script&lang=js"
export * from "./SignTermsAndConditions.vue?vue&type=script&lang=js"
import style0 from "./SignTermsAndConditions.vue?vue&type=style&index=0&id=941235cc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "941235cc",
  null
  
)

export default component.exports